import { importOnInteraction } from '@studiometa/js-toolkit';
import { Panel } from '@studiometa/ui';

/**
 * Search component
 */
export default class Search extends Panel {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Search',
    components: {
      Autocomplete: (app) =>
        importOnInteraction(() => import('./Autocomplete.js'), app.$refs.open, 'click'),
    },
  };

  /**
   * open
   */
  async open() {
    await super.open();
    const input = this.$el.querySelector('input[name="q"]');

    if (input) {
      input.focus();
    }
  }
}
